import type { Signal } from "app/pages/sales-intelligence/domain/signals/types/signal";
import { isSignalTypeKey } from "app/pages/sales-intelligence/domain/signals/utils/signal-key";

import { getSignalTrackingValues } from "../../../../../sub-modules/signals/services/tracking/signals-management/helpers";

import type { LeadsFiltersTrackingFormatter } from "./types";

export const createSignalFilterFormatter = (): LeadsFiltersTrackingFormatter => {
    return {
        keys: isSignalTypeKey,
        format(_filterKey, value): string {
            const signals = value as readonly Signal[] | undefined;

            if (!signals?.length) {
                return "";
            }

            return JSON.stringify(signals.map((signal) => getSignalTrackingValues(signal)));
        },
    };
};
